import * as React from "react";
import { connect } from "react-redux";
import Component from "../../AbstractComponent";
import { TabsComponent } from "./TabsComponent";
import Constants from "../../../Action/Constants";
import * as uuidV4 from "uuid/v4";
import ReportTypeContainer from "../../../Entity/Entities/Report/ReportType/ReportTypeContainer";
import Time from "../../../Time/Time";
import Select from "../../Partials/Material/Select";
import Card from '@material-ui/core/Card';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Button from "@material-ui/core/Button";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import CasedeskUrl from "../../../Url/Url";

class Reports extends Component {
  public state = {
    selectedPeriodForBalanceReport: Time.momentify(Time.firstDateCurrentMonth()).format("YYYY-MM-DD"),
    selectedPeriodForBooklistReport: Time.momentify(Time.firstDateCurrentMonth()).format("YYYY-MM-DD"),
    expanded: null,
    isSaving: false
  };

  constructor(public props) {
    super(props);
  }

  public handleChangeExpansionPanel = panel => (event, expanded) => {
    event
    this.setState({
      expanded: expanded ? panel : false,
    });
  };

  public downloadPaylist = () => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_REPORT_DOWNLOAD_START,
        payload: {
          amazonFolderName: uuidV4(),
          reportTypeId: ReportTypeContainer.pickIdFromLabel("payables"),
          localTime: this.formatter.formatTime(new Date())
        },
        onSuccess: url => {
          this.setState({
            isSaving: false
          });

          window.open(CasedeskUrl.getAttachment(url), "_blank")
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public downloadOverview = () => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_REPORT_DOWNLOAD_START,
        payload: {
          amazonFolderName: uuidV4(),
          reportTypeId: ReportTypeContainer.pickIdFromLabel("receivables"),
          localTime: this.formatter.formatTime(new Date())
        },
        onSuccess: url => {
          this.setState({
            isSaving: false
          });

          window.open(CasedeskUrl.getAttachment(url), "_blank")
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public downloadBalance = () => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_REPORT_DOWNLOAD_START,
        payload: {
          period: this.state.selectedPeriodForBalanceReport,
          amazonFolderName: uuidV4(),
          reportTypeId: ReportTypeContainer.pickIdFromLabel("balances"),
          localTime: this.formatter.formatTime(new Date())
        },
        onSuccess: url => {
          this.setState({
            isSaving: false
          });

          window.open(CasedeskUrl.getAttachment(url), "_blank")
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public downloadBooklist = () => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_REPORT_DOWNLOAD_START,
        payload: {
          period: this.state.selectedPeriodForBooklistReport,
          amazonFolderName: uuidV4(),
          reportTypeId: ReportTypeContainer.pickIdFromLabel("journal"),
          localTime: this.formatter.formatTime(new Date())
        },
        onSuccess: url => {
          this.setState({
            isSaving: false
          });

          window.open(CasedeskUrl.getAttachment(url), "_blank")
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public changeReportPeriodForBalanceReport = (event) => {
    this.setState({selectedPeriodForBalanceReport: event.target.value});
  }

  public changeReportPeriodForBooklistReport = (event) => {
    this.setState({selectedPeriodForBooklistReport: event.target.value});
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-finance full-width has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-finance")}</h1>
            <TabsComponent
              activeTab={4}
              {...this.props}
            />
          </div>

          <div className="component-wrapper no-borders no-margin-top">
            <Card className="card">
              <div style={{width: "100%"}}>
                <ExpansionPanel className="expansion-panel" expanded={this.state.expanded === 'paylist'} onChange={this.handleChangeExpansionPanel('paylist')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    {
                      <div className="expansion-panel-title">{this.trans("page/reports-tab/paylist-title")}</div>
                    }
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Card className="card">
                      <div style={{display: "flex", alignItems: "center"}}>
                        <div>
                          {this.trans("page/reports-tab/paylist-info")}
                        </div>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.downloadPaylist}
                          style={{marginLeft: "20px"}}
                        >
                          {this.trans("button-download")}
                        </Button>
                      </div>
                    </Card>
                  </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel className="expansion-panel" expanded={this.state.expanded === 'overview'} onChange={this.handleChangeExpansionPanel('overview')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    {
                      <div className="expansion-panel-title">{this.trans("page/reports-tab/overview-title")}</div>
                    }
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Card className="card">
                      <div style={{display: "flex", alignItems: "center"}}>
                        <div>
                          {this.trans("page/reports-tab/overview-info")}
                        </div>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.downloadOverview}
                          style={{marginLeft: "20px"}}
                        >
                          {this.trans("button-download")}
                        </Button>
                      </div>
                    </Card>
                  </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel className="expansion-panel" expanded={this.state.expanded === 'balance'} onChange={this.handleChangeExpansionPanel('balance')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>            
                    {
                      <div className="expansion-panel-title">{this.trans("page/reports-tab/balance-title")}</div>
                    }
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Card className="card">
                      <div style={{display: "flex", alignItems: "center"}}>
                        <div>
                          {this.trans("page/reports-tab/balance-info")}
                        </div>
                        <Select
                          value={this.state.selectedPeriodForBalanceReport}
                          onChange={this.changeReportPeriodForBalanceReport}
                          name="reportPeriod" 
                          id="reportPeriod"
                          style={{margin: "0 20px 0 10px"}}
                          error={null}
                        >
                          {this.getSixMonthsForReportsSelectboxes()}
                        </Select>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.downloadBalance}
                        >
                          {this.trans("button-download")}
                        </Button>
                      </div>
                    </Card>
                  </ExpansionPanelDetails>
                </ExpansionPanel>

                <ExpansionPanel className="expansion-panel" expanded={this.state.expanded === 'booklist'} onChange={this.handleChangeExpansionPanel('booklist')}>
                  <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                    {
                      <div className="expansion-panel-title">{this.trans("page/reports-tab/booklist-title")}</div>
                    }
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <Card className="card">
                      <div style={{display: "flex", alignItems: "center"}}>
                        <div>
                          {this.trans("page/reports-tab/booklist-info")}
                        </div>
                        <Select
                          value={this.state.selectedPeriodForBooklistReport}
                          onChange={this.changeReportPeriodForBooklistReport}
                          name="reportPeriod" 
                          id="reportPeriod"
                          style={{margin: "0 20px 0 10px"}}
                          error={null}
                        >
                          {this.getTwoYearsForReportsSelectboxes()}
                          {this.getSixMonthsForReportsSelectboxes()}
                        </Select>

                        <Button
                          variant="contained"
                          color="primary"
                          onClick={this.downloadBooklist}
                        >
                          {this.trans("button-download")}
                        </Button>
                      </div>
                    </Card>
                  </ExpansionPanelDetails>
                </ExpansionPanel>
              </div>
            </Card>
          </div>
        </div>

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    component: state.reports,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(
  Reports
);
